import React, {Component} from 'react';
import Swiper from 'react-id-swiper';
import {observer, inject} from 'mobx-react';
import moment from 'moment'
import ReactGA from 'react-ga';

@inject('store')
@observer
class MediaPage extends Component {

    // constructor() {
    // 	super();
    // }

    componentDidMount() {
        this.initializeReactGA();
        window.scrollTo(0, 0);
        this.props.store.homeType(false);


    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/media');
    }

    render() {

        const mediaScreen = {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            loop: true,
            slidesPerView: 3,
            spaceBetween: 15,
            autoplay: {
                delay: 10000,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 5
                },
                580: {
                    slidesPerView: 1,
                    spaceBetween: 5
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
            }
        }
        return (
            <section className="slider_loan">
                <div className="container" data-aos="zoom-in" data-aos-delay="100">


                    <div className="cara_slider newAdditon">
                        <Swiper {...mediaScreen} >
                            {
                                this.props.screendata.map((res, index) => (
                                    <div className="swiper-slide" key={index}>
                                        <div className="slider_pannel" style={{
                                            height: "270px"
                                        }}><span className="date"><span
                                            className="text-orange">{moment(res.date).format("D MMM'YY")}</span></span>
                                            <a href={res.link} target="_blank" key={index}>

                                                <div className="logopt">
                                                    <img src={res.image} alt=''/>
                                                </div>

                                                <div className="full-w"
                                                     style={{
                                                         display: "flex",
                                                         justifyContent: "center",
                                                     }}>
                                                    <p className="fz-13 lcolor mgt-10">{res.description}</p>
                                                    <div className="media-heading"
                                                         style={{
                                                             display: "flex",
                                                             justifyContent: "center",
                                                             position: "absolute",
                                                             bottom: "40px"
                                                         }}>
                                                        <div>
                                                            <div className="dblue"
                                                                 style={{
                                                                     fontSize: "13px",
                                                                     fontWeight: "bold",
                                                                 }}>{res.linkname}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </a>
                                        </div>
                                    </div>
                                ))
                            }
                        </Swiper>
                    </div>
                </div>
            </section>

        )
    }
}


export default MediaPage



// WEBPACK FOOTER //
// ./src/components/mediapage.js